import {v4 as uuidv4} from 'uuid';

const servicesFourData = [
    {
        id: uuidv4(),
        icon: 'coding',
        title: 'Web Development',
        desc: 'Web development service agency may sound good but it typically refers more traditional service',
    },

    {
        id: uuidv4(),
        icon: 'bullhorn',
        title: 'Digital Marketing',
        desc: 'Web development service agency may sound good but it typically refers more traditional service',
    },

    {
        id: uuidv4(),
        icon: 'writing',
        title: 'SEO & Content Writing',
        desc: 'Web development service agency may sound good but it typically refers more traditional service',
    },

    {
        id: uuidv4(),
        icon: 'curve',
        title: 'UI/UX Design',
        desc: 'Web development service agency may sound good but it typically refers more traditional service',
    },

    {
        id: uuidv4(),
        icon: 'brainstorming',
        title: 'Consultancy',
        desc: 'Web development service agency may sound good but it typically refers more traditional service',
    },
    
]

export default servicesFourData;